import { render, staticRenderFns } from "./onebox-register.vue?vue&type=template&id=6cf472a2&scoped=true&"
import script from "./onebox-register.vue?vue&type=script&lang=js&"
export * from "./onebox-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf472a2",
  null
  
)

export default component.exports